"use client";

/* eslint-disable */
import React from "react";
import {
  Card,
  Grid,
  Group,
  Text,
  Badge,
  Container,
  Title,
  Box,
} from "@mantine/core";
import { useGetAttendanceSummary } from "api/attendance/getAttendanceSummary";

interface AttendanceMetric {
  label: string;
  value: number;
  change: number;
  isPositive: boolean;
}

export default function AdminAttendanceDetail() {
  const { data, isLoading } = useGetAttendanceSummary();
  const metrics: AttendanceMetric[] = [
    {
      label: "Present",
      value: data?.data.present.count ?? 0,
      change: data?.data.present.percentageChange ?? 0,
      isPositive: (data?.data.present.percentageChange ?? 0) >= 50,
    },
    {
      label: "Late Login",
      value: data?.data.lateLogin.count ?? 0,
      change: data?.data.lateLogin.percentageChange ?? 0,
      isPositive: (data?.data.lateLogin.percentageChange ?? 0) >= 50,
    },
    {
      label: "Absent",
      value: data?.data.absent.count ?? 0,
      change: data?.data.absent.percentageChange ?? 0,
      isPositive: (data?.data.absent.percentageChange ?? 0) >= 50,
    },
  ];

  return (
    <Box
      sx={(theme) => ({
        // backgroundColor:
        //   theme.colorScheme === "dark" ? theme.colors.dark[7] : "#f8f9fa",
        // fontFamily: "Arial, sans-serif",
        // padding: theme.spacing.lg,
        width: "100%",
        // marginBottom: "10px",
      })}
    >
      {/* Header */}

      {/* Metrics Grid */}
      <Grid
        gutter="md"
        mt="lg"
        align="stretch"
        sx={{
          // make grid fluid & responsive
          "@media (min-width: 1400px)": {
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          },
        }}
      >
        {metrics.map((metric) => (
          <Grid.Col
            key={metric.label}
            xs={3}
            sm={3}
            md={3}
            xl={3}
            sx={{ display: "flex" }}
          >
            <Card
              withBorder
              radius="sm"
              shadow="xs"
              w="100%"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Text size="xs" c="dimmed" fw={500}>
                {metric.label}
              </Text>
              <Text size="xl" fw={700} c="#1a1a1a">
                {metric.value}
              </Text>
              <Badge
                variant="light"
                color={metric.isPositive ? "green" : "red"}
              >
                {Math.abs(metric.change)}%
              </Badge>
            </Card>
          </Grid.Col>
        ))}
      </Grid>
    </Box>
  );
}
